import React from 'react';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import Button from './ui/button';
import screens from '../@style/screens';

interface FilterItem {
  name: string;
  link?: string;
  selected?: boolean;
  onClick?: () => void;
}

interface Props {
  items: FilterItem[];
}

const FiltersWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  height: 80px;
  width: 100%;
  @media ${screens.laptop} {
    height: 150px;
  }
  * {
    font-weight: 400 !important;
  }
`;

const Filters: React.FC<Props> = ({ items }) => {
  return (
    <FiltersWrapper>
      <Swiper
        slidesPerView="auto"
        spaceBetween={10}
        breakpoints={{
          720: {
            spaceBetween: 30,
            slidesPerView: 'auto',
          },
        }}
      >
        {items.map((filter, index) => (
          <SwiperSlide key={index}>
            <Button
              link={filter.link}
              type={filter.link ? 'internal' : undefined}
              buttonStyle="fit"
              selected={filter.selected}
              onClick={() => filter.onClick?.()}
            >
              {filter.name}
            </Button>
          </SwiperSlide>
        ))}
      </Swiper>
    </FiltersWrapper>
  );
};

export default Filters;
